<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('表编号')">
              <a-input :placeholder="$t('请输入表编号')" v-model="queryParam.searchMeterId"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('返厂状态')">
              <j-dict-select-tag v-model="queryParam.returnedState" :showSearch="false" :placeholder="$t('请选择返厂状态')" dictCode="returned_state" />
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('返厂日期')">
              <a-range-picker
                v-model="date"
                format="YYYY-MM-DD"
                :placeholder="[$t('查询起始时间'), $t('查询结束时间')]"
                @change="onDateRangeChange"
              />
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('操作员')">
              <j-select-user-by-dep v-model="queryParam.returnedBy" :multi="false"></j-select-user-by-dep>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              <a-button @click="handleAdd" type="primary" icon="plus" style="margin-left: 8px">{{ $t('新增') }}</a-button>
              <a-button type="primary" icon="download" @click="handleExportXls($t('返厂记录'))" style="margin-left: 8px"
                >{{ $t('导出') }}</a-button
              >
              <a-upload
                name="file"
                :showUploadList="false"
                :multiple="false"
                :headers="tokenHeader"
                :action="importExcelUrl"
                @change="handleImportExcel"
              >
                <a-button type="primary" icon="import" style="margin-left: 8px">{{ $t('导入') }}</a-button>
              </a-upload>
              <a-button type="link" icon="download" @click="downloadFormWork($t('返厂模板'))">{{ $t('下载模板') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="flex flex-center" style="margin-bottom: 15px">
      <div class="flex-item" style="height: 80px" v-for="item in totalList" :key="item.key">
        <div class="flex-center" style="height: 100%;background: #e6f7ff;border: 1px solid #91d5ff;flex-direction: column;">
          <div class="flex-center">
            <span class="" style="margin-left:10px;font-size:24px;font-weight: 500">{{item.num}}</span>
            <span class="unit" style="color: #999999">{{item.unit}}</span>
          </div>
          <div class="flex-center" style="color: #999999">{{item.title}}</div>
        </div>
      </div>
    </div>
    <!-- table区域-begin -->
    <div class="table-fixed">
      <a-table
        ref="table"
        size="middle"
        :scroll="{ x: true }"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :components="drag(columns)"
        @change="handleTableChange"
      >
        <span slot="userAccount" slot-scope="text, record">
          <a-tag
            style="font-size: 14px"
            :color="
              record.userAccountNum == null
                ? ''
                : record.userAccountNum <= 0
                ? 'red'
                : record.wtAlarmMoney < record.userAccountNum
                ? 'green'
                : 'orange'
            "
            >{{ record.userAccountNum }}</a-tag
          >
        </span>
        <template slot="userStateSlot" slot-scope="text">
          <a-button :class="text == 1 ? 'normalbg-status' : text == 0 ? 'unactivebg-status' : ''" v-if="text != null">
            {{ text == 1 ? $t('已激活') : text == 0 ? $t('未激活') : '' }}
          </a-button>
        </template>
        <template slot="returnedState" slot-scope="text, record">
          <a-tag style="font-size: 14px" :color="text == 2 ? 'green' : text == 3 ? 'red' : 'blue'">{{
            filterDictTextByCache('returned_state', text)
          }}</a-tag>
        </template>
        <template slot="inspectionState" slot-scope="text, record">
          <a-tag style="font-size: 14px" :color="text == 1 ? 'green' : 'red'">{{
            filterDictTextByCache('verification_results', text)
          }}</a-tag>
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{ $t('编辑') }}</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{ $t('更多') }} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">{{ $t('详情') }}</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm :title="$t('确定删除吗?')" @confirm="() => handleDelete(record.id)">
                  <a>{{ $t('删除') }}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>
    <ReturnToFactoryModal ref="modalForm" @ok="modalFormOk" />
  </a-card>
</template>
    <script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { isUndefined, isEmptyObject } from '@/utils/validate'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { listSize,fileUrl } from '@/utils/util'
import { getAction, deleteAction } from '@/api/manage'
import { filterDictTextByCache } from '@/components/dict/JDictSelectUtil'
import TableDragResize from '@/mixins/TableDragResize'
import JInput from '@/components/jeecg/JInput'
import JSelectUserByDep from '@/components/jeecgbiz/JSelectUserByDep'
import ReturnToFactoryModal from './ReturnToFactoryModal.vue'
import JDictSelectTag from '../../components/dict/JDictSelectTag.vue'

export default {
  name: 'ReturnToFactoryManagementList',
  mixins: [JeecgListMixin, mixinDevice, TableDragResize],
  components: {
    JInput,
    JSelectUserByDep,
    ReturnToFactoryModal,
    JDictSelectTag,
  },
  data() {
    return {
      filterDictTextByCache: filterDictTextByCache,
      userTypeList: [], //表类型
      userCaliberList: [], // 表口径
      description: 'meterinfo管理页面',
      url: {
        list: '/jeecg-charge/meterReturnedRecord/list',
        exportXlsUrl: '/jeecg-charge/meterReturnedRecord/exportXls',
        importExcelUrl: 'jeecg-charge/meterReturnedRecord/importExcel',
        delete: '/jeecg-charge/meterReturnedRecord/delete',
        userTypeList: '/jeecg-charge/meter/meterType/list', //表类型请求地址
        userCaliberList: '/jeecg-charge/meter/meterCaliber/list', //表口径请求地址
        getCount: "/jeecg-charge/meterInspectionRecord/getCount", //获取条目总数
      },
      // 统计项数值（totalList 改为 computed 后由此响应式承接）
      statData: {
        meterCount: '',
        usageMeterCount: '',
        returnedCount: '',
        repairRate: '',
      }
    }
  },
  activated() {},
  created() {
    this.queryUserTypeList()
    this.queryUserCaliberList()
    console.log('执行creted生命周期')
    this.getTotalCount();
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
    // i18n：统计项标题使用 computed 以响应语言切换
    totalList() {
      return [
        { key: 1, title: this.$t('表总数量'), num: this.statData.meterCount, unit: this.$t('只') },
        { key: 2, title: this.$t('安装数量'), num: this.statData.usageMeterCount, unit: this.$t('只') },
        { key: 3, title: this.$t('返厂数量'), num: this.statData.returnedCount, unit: this.$t('只') },
        { key: 4, title: this.$t('修复率'), num: this.statData.repairRate, unit: '%' },
      ]
    },
    // i18n：表头使用 computed 以响应语言切换
    columns() {
      return [
        {
          title: '#',
          dataIndex: 'index',
          width: 60,
          align: 'center',
          customRender: (t, r, index) => {
            return parseInt(index) + 1
          },
        },
        {
          title: this.$t('表编号'),
          dataIndex: 'meterId',
          align: 'center',
        },
        {
          title: this.$t('表口径'),
          dataIndex: 'caliber',
          align: 'center',
          customRender: t => 'DN' + t,
        },
        {
          title: this.$t('表类型'),
          dataIndex: 'mtName',
          align: 'center',
        },
        {
          title: this.$t('返厂状态'),
          dataIndex: 'returnedState',
          align: 'center',
          scopedSlots: { customRender: 'returnedState' },
        },
        {
          title: this.$t('返厂原因'),
          dataIndex: 'returnedType',
          align: 'center',
          customRender: t => {
            return filterDictTextByCache('returned_reason', t)
          },
        },
        {
          title: this.$t('返厂日期'),
          dataIndex: 'returnedTime',
          align: 'center',
        },
        {
          title: this.$t('操作员'),
          dataIndex: 'returnedByName',
          align: 'center',
        },
        {
          title: this.$t('完成日期'),
          dataIndex: 'finishedTime',
          align: 'center',
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' },
        },
      ]
    },
  },
  methods: {
    getTotalCount() {
      getAction(this.url.getCount).then(res => {
        if (res.success) {
          let result = res.result
          for (const key in result) {
            if(key=='meterCount') this.statData.meterCount = result[key];
            if(key=='usageMeterCount') this.statData.usageMeterCount = result[key];
            if(key=='returnedMeterCount') this.statData.returnedCount = result[key];
            if(key=='repairRate') this.statData.repairRate = result[key];
          }
        }
      })
    },
    loadData(arg) {
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1
      }
      var params = this.getQueryParams() //查询条件
      this.loading = true
      getAction(this.url.list, params).then(res => {
        if (res.success && res.result) {
          this.dataSource = res.result.records
          this.ipagination.total = res.result.total
        } else {
          this.$message.warning(res.message)
        }
        this.loading = false
      })
    },
    queryUserTypeList() {
      //表类型请求
      let params = {}
      params.pageNo = 1
      params.pageSize = listSize
      getAction(this.url.userTypeList, params).then(res => {
        if (res.success) {
          this.userTypeList = res.result.records
        }
      })
    },
    queryUserCaliberList() {
      //表口径请求
      let params = {}
      params.pageNo = 1
      params.pageSize = listSize
      params.column = 'mtCaliber'
      params.order = 'asc'
      getAction(this.url.userCaliberList, params).then(res => {
        if (res.success) {
          this.userCaliberList = res.result.records
        }
      })
    },
    downloadFormWork(fileName) {
      console.log('下载批量报装模板')
      let deviceFileUrl = '/file/return_to_factory_template.xls'
      let url = `${fileUrl}${deviceFileUrl}`
      if (!fileName || typeof fileName != 'string') {
        fileName = this.$t('导出文件')
      }
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      console.log(fileName)
      link.setAttribute('download', fileName + '.xls')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link) //下载完成移除元素
      window.URL.revokeObjectURL(link.href) //释放掉blob对象
    },
  },
}
</script>
    <style scoped>
.table-fixed /deep/ .ant-table-bordered .ant-table-fixed-left table {
  border-right: 1px solid #e8e8e8;
}

.table-fixed /deep/ .resize-table-th {
  position: relative;
}
.table-fixed /deep/ .table-draggable-handle {
  border: 1px solid red;
  height: 100% !important;
  left: auto !important;
  right: -5px;
  cursor: col-resize;
  touch-action: none;
  border: none;
  position: absolute;
  transform: none !important;
  bottom: 0;
}
</style>